import { render, staticRenderFns } from "./DefaultsTool.vue?vue&type=template&id=7881f432&"
import script from "./DefaultsTool.vue?vue&type=script&lang=js&"
export * from "./DefaultsTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports